module.exports = {"rechargeValueLabel":"O valor da sua recarga escolhida foi:","valueLabel":"Valor da Recarga:","currency":"R$","button":"continue","titleModalError":"Tem algo errado com os dados do seu cartão. Tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditPaymentCreditCard/data.json
// module id = 2199
// module chunks = 0